export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9aBB5k3wJxArepzhN.538a4a44.woff2";